import { feathers } from '@/feathers-client';
import facebookSourceType from '../config/facebook-source-types';

const initialState = {
  fbPermissions: {
    fbPersonal: {},
    fbLiondesk: {},
  },
  fbPersonalAdAccounts: [],
  fbLiondeskAdAccount: {},
  fbAccountType: facebookSourceType.fbLiondesk.type,
  showCustomAudienceErrorMessage: false,
  customAudienceErrorMessage: '',
  isSavingAdAccounts: false,
};

export default {
  namespaced: true,
  state: {
    ...initialState,
  },
  getters: {
    isPersonalFbConnected: state => {
      return !!state.fbPermissions.fbPersonal.token_exists;
    },
    isFbConnected: state => {
      return !!state.fbPermissions[state.fbAccountType].token_exists;
    },
    hasAdsManagementPermission: ({ fbPermissions, fbAccountType }) => {
      const { permissions } = fbPermissions[fbAccountType];
      if (permissions) {
        return permissions.some(
          p => p.permission === 'ads_management' && p.status === 'granted',
        );
      }
      return false;
    },
  },
  mutations: {
    setFbPermissionsData(state, fbData) {
      state.fbPermissions[fbData.fbType] = fbData.fbPermissionsData;
    },
    setFbPersonalAdAccounts(state, fbAdAccounts) {
      state.fbPersonalAdAccounts = fbAdAccounts;
    },
    setFbLiondeskAdAccount(state, fbAdAccount) {
      state.fbLiondeskAdAccount = fbAdAccount;
    },
    setFbAccountType(state, type) {
      state.fbAccountType = type;
    },
    setCustomAudienceErrorMessage(state, errorMessage) {
      state.customAudienceErrorMessage = errorMessage;
    },
    setShowCustomAudienceErrorMessage(state, value) {
      state.showCustomAudienceErrorMessage = value;
    },
    setIsSavingAdAccounts(state, boolean) {
      state.isSavingAdAccounts = boolean;
    },
  },
  actions: {
    async getFacebookPermissions({ commit }, fbUser) {
      try {
        const query = {
          fb_user_type_id: fbUser.id,
        };
        const response = await feathers.service('fb-connected-user-permissions').find({ query });

        const fbData = {
          fbType: fbUser.type,
          fbPermissionsData: response,
        };

        commit('setFbPermissionsData', fbData);
      } catch (err) {
        commit('setCustomAudienceErrorMessage', err.message);
        commit('setShowCustomAudienceErrorMessage', true);
      }
    },
    async getFbAdAccount({ commit, state }) {
      try {
        const { data } = await feathers.service('fb-connected-ad-accounts').find({
          query: { fb_user_type_id: facebookSourceType[state.fbAccountType].id },
        });
        if (!data || !data.length) {
          return;
        }
        if (facebookSourceType.fbPersonal.type === state.fbAccountType) {
          commit('setFbPersonalAdAccounts', data);
        } else {
          commit('setFbLiondeskAdAccount', data[0]);
        }
      } catch (err) {
        commit('setCustomAudienceErrorMessage', err.message);
        commit('setShowCustomAudienceErrorMessage', true);
      }
    },
    async transferInternalFbToUser({ commit }) {
      try {
        await feathers.service('fb-internal-account').create({});
      } catch (err) {
        commit('setCustomAudienceErrorMessage', err.message);
        commit('setShowCustomAudienceErrorMessage', true);
      }
    },
    async deactivateFbUser({ commit }) {
      try {
        await feathers.service('fb-deactivate-connected-users').patch(0, {});
        commit('setFbPersonalAdAccounts', []);
      } catch (err) {
        commit('setCustomAudienceErrorMessage', err.message);
        commit('setShowCustomAudienceErrorMessage', true);
      }
    },
  },
};
